import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=1ec11c4a&"
import script from "./ShippingInfo.vue?vue&type=script&lang=ts&"
export * from "./ShippingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports